import { QueryUtils } from '@shared/utils';

interface SearchHighlightProps {
  className?: string;
  searchText?: string;
  children: string;
}

export const SearchHighlight = (props: SearchHighlightProps) => {
  const prepareChild = (child: string) => {
    const queryTest = QueryUtils.getSearchQuery(props.searchText || '');

    if (props.searchText) return child?.replace(queryTest, (res) => `<mark class="text-[#e32d33]" style="background: none">${res}</mark>`);
    return child;
  };

  return <span dangerouslySetInnerHTML={{ __html: prepareChild(props.children) }} />;
};
